let messageSendInFlight = false;

export const isMessageSendInFlight = () => messageSendInFlight;

export const setMessageSendInFlight = (value) => {
    messageSendInFlight = value === true;
};
